
// ---------- state ----------
const DATA=window.CLAUDE_PDP;
const META=Object.assign({original:{name:"Original · 150°F",bar:"62%"},highheat:{name:"High Heat · 180°F",bar:"88%"}},DATA.meta||{});
let variant="original",pay="full",qty=1;
const $=id=>document.getElementById(id);
const fmt=c=>"$"+Math.round(c/100).toLocaleString();
const curVariant=()=>pay==="deposit"?DATA.variants[variant].deposit:DATA.variants[variant].full;

// ---------- direct checkout ----------
async function buyNow(vid,q,btn){
 const orig=btn.innerHTML;btn.innerHTML="One moment…";btn.disabled=true;
 try{
  const r=await fetch("/cart/add.js",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({items:[{id:vid,quantity:q}]})});
  if(!r.ok)throw new Error("cart");
  window.location.href="/checkout";
 }catch(e){btn.innerHTML=orig;btn.disabled=false;alert("Something went wrong — please try again.");}
}
document.addEventListener("click",function(e){
 const b=e.target.closest("[data-buy]");if(!b||b.disabled)return;
 e.preventDefault();
 const k=b.getAttribute("data-buy");let vid=null,q=1;
 if(k==="current"){vid=curVariant().id;q=qty;}
 else if(DATA.variants[k])vid=DATA.variants[k].full.id;
 if(vid)buyNow(vid,q,b);
});
// footer CTA (shared claude-pdp-b section) → direct checkout
(function(){
 const cb=document.getElementById("ctaBtn");if(!cb)return;
 if(DATA.variants.highheat){
  const duo=document.createElement("div");duo.className="cta-duo";
  duo.innerHTML='<button type="button" class="btn btn-ghost" data-buy="original">SweatBox Original · 150°F</button><button type="button" class="btn btn-ember" data-buy="highheat">High Heat Upgrade · 180°F (+$400)</button>';
  cb.replaceWith(duo);
 }else{
  cb.removeAttribute("href");cb.setAttribute("role","button");cb.setAttribute("data-buy","original");
 }
})();

function render(){
 const vv=DATA.variants[variant],m=META[variant];
 const isDep=pay==="deposit";
 const saleFull=vv.full.price-DATA.discount;
 const unit=isDep?vv.deposit.price:saleFull;
 const price=unit*qty;
 $("priceNow").textContent=fmt(price);
 $("priceWas").textContent=isDep?"":fmt(vv.full.price*qty);
 $("priceWas").style.display=isDep?"none":"";
 $("priceSave").textContent=isDep?"Locks sale price":"Save "+fmt(DATA.discount*qty);
 $("finLine").innerHTML=isDep
   ?"Balance of <b>"+fmt((saleFull-vv.deposit.price)*qty)+"</b> due before fulfillment · sale price locked"
   :"or from <b>$"+Math.round(saleFull/100/24).toLocaleString()+"/mo</b> · 0% APR up to 24 months with Klarna or Affirm";
 $("payNote").textContent=isDep?"Reserve now from "+fmt(vv.deposit.price)+" — pay the rest before your box ships.":"Own it outright — sale price locked at checkout.";
 $("atcBtn").innerHTML=(isDep?"Reserve — ":"Buy now — ")+fmt(price)+"<small>Free shipping · ships from Oregon</small>";
 $("stickyPrice").textContent=fmt(price);
 $("stickyV").textContent=m.name+(isDep?" · deposit":"");
 const cbEl=$("ctaBtn");if(cbEl)cbEl.textContent="Buy now — "+fmt(saleFull);
 $("qty").textContent=qty;
 document.querySelectorAll(".vcard").forEach(b=>{
  const on=b.dataset.v===variant;
  b.classList.toggle("is-active",on);b.setAttribute("aria-checked",on);
  b.querySelector(".vbar i").style.width=on?META[b.dataset.v].bar:"62%";
 });
 document.querySelectorAll(".pay-toggle button").forEach(x=>x.classList.toggle("is-active",x.dataset.p===pay));
 document.querySelectorAll(".sticky-tog button[data-sv]").forEach(b=>b.classList.toggle("is-active",b.dataset.sv===variant));
 document.querySelectorAll(".sticky-tog button[data-sp]").forEach(b=>b.classList.toggle("is-active",b.dataset.sp===pay));
}
document.querySelectorAll(".sticky-tog button[data-sv]").forEach(b=>b.addEventListener("click",()=>{variant=b.dataset.sv;render();}));
document.querySelectorAll(".sticky-tog button[data-sp]").forEach(b=>b.addEventListener("click",()=>{pay=b.dataset.sp;render();}));
document.querySelectorAll(".vcard").forEach(b=>b.addEventListener("click",()=>{if(DATA.variants[b.dataset.v]){variant=b.dataset.v;render();}}));
document.querySelectorAll(".pay-toggle button").forEach(b=>b.addEventListener("click",()=>{
 pay=b.dataset.p;render();
}));
$("atcBtn").addEventListener("click",async()=>{
 const btn=$("atcBtn");const orig=btn.innerHTML;btn.innerHTML="Adding…";btn.disabled=true;
 try{
  const r=await fetch("/cart/add.js",{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({items:[{id:curVariant().id,quantity:qty}]})});
  if(!r.ok)throw new Error("cart");
  window.location.href="/checkout";
 }catch(e){btn.innerHTML=orig;btn.disabled=false;alert("Something went wrong adding to cart — please try again.");}
});
$("qMinus").onclick=()=>{qty=Math.max(1,qty-1);render()};
$("qPlus").onclick=()=>{qty=Math.min(5,qty+1);render()};
render();

// ---------- countdown + self-updating sale end date ----------
// Countdown runs to midnight, holds at 00:00:00 until the restart hour, then resets.
// The date in the offer line runs off the same clock:
//   - blank setting        -> current sale day, rolls forward at the restart hour
//   - future date typed    -> held at that date until it passes
//   - past date typed      -> ignored, falls back to the current sale day
//   - unparseable text     -> printed exactly as typed
function fmtDay(d){return d.toLocaleDateString("en-US",{weekday:"long",month:"long",day:"numeric"});}
function parseEnd(s,ref){
 var t=String(s||"").trim().replace(/^[A-Za-z]+day,?\s+/,"").replace(/[.,]+\s*$/,"");
 if(!t)return null;
 var d,md=t.match(/^(\d{1,2})[\/\-.](\d{1,2})(?:[\/\-.](\d{2,4}))?$/);
 if(md){
  var y=md[3]?+md[3]:ref.getFullYear(); if(y<100)y+=2000;
  d=new Date(y,+md[1]-1,+md[2]);
 }else{
  var hasYear=/\b\d{4}\b/.test(t);
  d=new Date(hasYear?t:t+" "+ref.getFullYear());
  if(isNaN(d.getTime()))return null;
  d.setHours(0,0,0,0);
  // no year typed and it lands well in the past -> they meant next year
  if(!hasYear&&d.getTime()<ref.getTime()-3888e6){
   var d2=new Date(t+" "+(ref.getFullYear()+1));
   if(!isNaN(d2.getTime()))d=d2;
  }
 }
 if(isNaN(d.getTime()))return null;
 d.setHours(0,0,0,0);
 return d;
}
function cd(){
 const n=new Date();
 const rh=DATA.restartHour!=null?DATA.restartHour:7;
 const before=n.getHours()<rh;
 // the current "sale day" — before the restart hour we are still on yesterday's sale
 const day=new Date(n); if(before)day.setDate(day.getDate()-1); day.setHours(0,0,0,0);
 const de=document.getElementById("offerDate");
 if(de){
  const raw=(DATA.saleEnd||"").trim();
  let txt;
  if(!raw){ txt=fmtDay(day); }
  else{
   const p=parseEnd(raw,day);
   if(!p){ txt=raw; }
   else if(p.getTime()>=day.getTime()){ txt=fmtDay(p); }
   else { txt=fmtDay(day); }
  }
  if(de.textContent!==txt)de.textContent=txt;
 }
 if(before){ $("cd").textContent="00:00:00"; return; }
 const m=new Date(n); m.setHours(24,0,0,0);
 let s=Math.max(0,(m-n)/1e3|0);
 const h=String(s/3600|0).padStart(2,"0"),mi=String(s%3600/60|0).padStart(2,"0"),se=String(s%60).padStart(2,"0");
 $("cd").textContent=h+":"+mi+":"+se;
}
cd();setInterval(cd,1000);

// ---------- gallery: all product photos ----------
const IMGS=DATA.images;
let gi=0;
const thumbsEl=$("galThumbs");
IMGS.forEach((u,i)=>{
 const b=document.createElement("button");
 b.innerHTML='<img loading="lazy" src="'+u.replace(/width=1200/,'width=200')+'" alt="Sweat Box photo '+(i+1)+'">';
 b.addEventListener("click",()=>show(i));
 thumbsEl.appendChild(b);
});
const FLAG_BOTTOM=(DATA.flagBottom||[]).map(n=>n-1);
function show(i){
 gi=(i+IMGS.length)%IMGS.length;
 $("galImg").src=IMGS[gi];
 $("galCount").textContent=(gi+1)+" / "+IMGS.length;
 document.querySelector(".gal-flag").classList.toggle("flag-bottom",FLAG_BOTTOM.includes(gi));
 thumbsEl.querySelectorAll("button").forEach((b,j)=>b.classList.toggle("is-active",j===gi));
 const act=thumbsEl.children[gi];if(act)act.scrollIntoView({block:"nearest",inline:"nearest",behavior:"smooth"});
}
$("galPrev").onclick=()=>show(gi-1);
$("galNext").onclick=()=>show(gi+1);
document.addEventListener("keydown",e=>{if(e.key==="ArrowLeft")show(gi-1);if(e.key==="ArrowRight")show(gi+1);});
let tx=0,ty=0;
const gm=$("galMain");
gm.addEventListener("touchstart",e=>{tx=e.touches[0].clientX;ty=e.touches[0].clientY;},{passive:true});
gm.addEventListener("touchend",e=>{
 const dx=e.changedTouches[0].clientX-tx,dy=e.changedTouches[0].clientY-ty;
 if(Math.abs(dx)>40&&Math.abs(dx)>Math.abs(dy))show(gi+(dx<0?1:-1));
},{passive:true});
show(0);

// ---------- heat lab ----------
const facts=DATA.heatFacts||[
 [72,"Ambient — ready when you are","This is your living room, garage, or studio corner. Plug into any standard outlet and it starts climbing — <b>no rewiring, no electrician, no permits.</b>"],
 [100,"Warming — first 10 minutes","Infrared works differently: it heats <b>you</b>, not just the air. Your skin temperature is already rising while a traditional sauna would still be preheating."],
 [120,"Deep sweat begins","Circulation is up, blood vessels dilate, and the red light bulbs are firing your mitochondria — <b>photothermal synergy</b> at work."],
 [150,"Original — max temperature","The Original's ceiling. With the heater right in front of you and infrared heating you from within, <b>150° feels like ~185°.</b> A deep, dripping, full-detox sweat."],
 [165,"High Heat territory","Only the High Heat upgrade climbs past here — stronger 150W bulbs, higher output, hand-selected wood built for it."],
 [180,"High Heat — max temperature","The ceiling of the High Heat upgrade. <b>Feels like 200°+</b> thanks to close heater proximity and infrared wavelengths. Heat-shock proteins, maximum sweat, traditional-sauna intensity from a 110V plug."]
];
const dial=$("dial"),photo=$("heatPhoto");
const dmin=+dial.min||72,dmax=+dial.max||180;
dial.addEventListener("input",()=>{
 const t=+dial.value;$("heatNum").textContent=t;
 photo.style.setProperty("--hh",(t-dmin)/(dmax-dmin));
 let f=facts[0];for(const x of facts){if(t>=x[0])f=x}
 $("heatState").textContent=f[1];$("heatFact").innerHTML=f[2];
});

// ---------- faq ----------
document.querySelectorAll(".faq-q").forEach(q=>q.addEventListener("click",()=>q.parentElement.classList.toggle("open")));

// ---------- reveal on scroll ----------
const io=new IntersectionObserver(es=>es.forEach(e=>{if(e.isIntersecting){e.target.classList.add("in");io.unobserve(e.target)}}),{threshold:.12});
document.querySelectorAll(".reveal").forEach(el=>io.observe(el));

// ---------- community marquee ----------
(function(){
 const F="https://cdn.shopify.com/s/files/1/0861/3589/8426/files/";
 const G=["sweatbox-gal-patio-dusk.png?v=1785281694","sweatbox-gal-garage-v2.png?v=1785362422","sweatbox-gal-wellness-v2.png?v=1785362422","sweatbox-gal-flash-night.png?v=1785281693","sweatbox-gal-sunroom-v2.png?v=1785362422","sweatbox-gal-midday.png?v=1785281694","sweatbox-gal-balcony.png?v=1785281694","sweatbox-gal-office-v2.png?v=1785362422","sweatbox-gal-porch-rain.png?v=1785281694","sweatbox-gal-spare-room.png?v=1785281693","sweatbox-gal-backlit-living.png?v=1785281694","sweatbox-gal-pergola.png?v=1785281694"];
 const tr=document.getElementById("mqTrack");
 [...G,...G].forEach(f=>{const im=document.createElement("img");im.loading="lazy";im.src=F+f+"&width=600";im.alt="";tr.appendChild(im);});
})();

// ---------- sticky bar ----------
const buy=document.getElementById("buy");
const io2=new IntersectionObserver(es=>es.forEach(e=>$("stickybar").classList.toggle("show",!e.isIntersecting)),{threshold:0});
io2.observe(buy);

// ---------- nav burger ----------
(function(){var b=document.getElementById('navBurger'),d=document.getElementById('navDrawer');if(b&&d){b.addEventListener('click',function(){var o=d.classList.toggle('open');b.classList.toggle('open',o);b.setAttribute('aria-expanded',o?'true':'false')});d.querySelectorAll('a').forEach(function(l){l.addEventListener('click',function(){d.classList.remove('open');b.classList.remove('open')})})}})();
